module.exports = __webpack_public_path__ + "img/webspace.28d9b4dc.svg";